module.exports = __webpack_public_path__ + "images/icon-user-survery-eedadfd4731ef680077fabd034d483a8.png";